import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SummaryType } from 'src/app/shared/model/summary-type';

@Component({
  selector: 'app-summary-selector',
  templateUrl: './summary-selector.component.html'
})
export class SummarySelectorComponent {

  @Output()
  type: EventEmitter<SummaryType> = new EventEmitter<SummaryType>();

  summaryTypes = Object.values(SummaryType);
  data: SummaryType;


  @Input()
  set initialState(value: SummaryType) {
    this.data = value;
  }

  changeValue(event: SummaryType): void {
    this.type.emit(event);
  }

}
